module.exports = __webpack_public_path__ + "res/Roboto-BoldItalic-webfont.svg?d62537a9583b7a66bdf6aa8922d85f76";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-BoldItalic-webfont.svg
// module id = 35
// module chunks = 0